// import "./navigation"
import "SLICK/slick.js";
import "MFP/jquery.magnific-popup.js";

// import "../third-party/magnific-popup/jquery.magnific-popup.min";
import "./togglize";
(function ($) {
  $(document).ready(function () {
    // console.log("starter theme...")
    $("#primary-nav-toggle").on("click", function slideMenu(e) {
      // console.log("burger click");
      let $this = $(this);
      let expanded = $this.attr("aria-expanded") == "true" || false;
      $this.attr("aria-expanded", !expanded);
      $this.siblings(".menu-primary-menu-container").toggleClass("open");
    });

    let $mainNavTopParentLinks = $("#primary-menu > .menu-item-has-children");
    let $mainNavParentLinks = $("#primary-menu .menu-item-has-children");
    $mainNavTopParentLinks.each(function setupHoverAction(index, item) {
      let $item = $(item);
      let timer = {};
      $item.on("mouseenter", function showSub(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          let $subMenu = $(this).children(".sub-menu");
          $subMenu.css({
            opacity: 1,
            visibility: "visible"
          });
          // reveal any opened submenus to retain their state
          $subMenu.find(".sub-menu.open").addClass("show");
          // still hovering, cancel closing of this menu
          clearTimeout(timer);
        }
      });
      $item.on("mouseleave", function maybeHideSubmenu(e) {
        if (window.matchMedia("(min-width: 981px)").matches) {
          timer = setTimeout(() => {
            let $subMenu = $(this).children(".sub-menu").first();
            // hide any open nested sub menus but don't close them, this retains their open state when hovering again
            $subMenu.find(".sub-menu.open").removeClass("show");
            // set opacity 0 to allow animate fading in.
            $subMenu.css({
              opacity: 0,
              visibility: "hidden"
            });
          }, 300);
        }
      });
    });

    // $mainNavTopParentLinks.on('blur','button',function() {
    //   console.log('blur');
    //   let $button = $(this);
    //   let expanded = $button.attr('aria-expanded') == 'true' || false;
    //   if (expanded) {
    //     $button.attr('aria-expanded', false);
    //     let $subMenu = $(this).siblings('.sub-menu').first();
    //     $subMenu.stop(true, false, true).slideToggle(300);
    //   }
    // });

    $mainNavTopParentLinks.on("keyup", function (e) {
      if (window.matchMedia("(min-width: 981px)").matches) {
        let spaceBar = 32;
        let enter = 13;
        if (e.keyCode == spaceBar || e.keyCode == enter) {
          let $button = $(this).children("button").first();
          let expanded = $button.attr("aria-expanded") == "true" || false;
          $button.attr("aria-expanded", !expanded);
          let $subMenu = $(this).children(".sub-menu").first();
          $subMenu.stop(true, false, true).slideToggle(300);
        }
      }
    });

    let $nestedSubMenuButtons = $("#primary-menu .sub-menu .menu-item-has-children button");

    $nestedSubMenuButtons.on("keyup", function (e) {
      e.stopPropagation();
    });

    $nestedSubMenuButtons.on("click", function (e) {
      e.stopPropagation();
      if (window.matchMedia("(min-width: 981px)").matches) {
        $(this).parents(".menu-item-has-children").children(".sub-menu").first().toggleClass(["open", "show"]);
      }
    });

    // Magnific popup for floor plans

    $(".pres-lightbox-image").magnificPopup({
      type: "image",
      image: {
        markup: '<div class="mfp-figure">' + '<div class="mfp-close"></div>' + '<div class="mfp-img"></div>' + '<div class="mfp-bottom-bar">' + '<div class="mfp-title"></div>' + '<div class="mfp-counter"></div>' + "</div>" + "</div>" // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
      },
      verticalFit: true // Fits image in area vertically
    });

    // gallery page images
    $(".gallery-grid").each(function (e) {
      $(this)
        .find("a.pres-lightbox-image")
        .magnificPopup({
          type: "image",
          gallery: {
            enabled: true,
            navigateByImgClick: true,

            arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

            tPrev: "Previous (Left arrow key)", // title for left button
            tNext: "Next (Right arrow key)", // title for right button
            tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
          },
          // callbacks: {
          //   buildControls: function () {
          //     // re-appends controls inside the main container
          //     this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
          //   }
          // },
          verticalFit: true // Fits image in area vertically
        });
    });

    // popup gallery functionality for floor plan "View Photos" button
    // $('.fp-gallery-button').on('click',function(e) {
    //   e.preventDefault();
    //   $(this).siblings("ul").
    //     .magnificPopup({
    //       // gallery: { enabled: true },
    //       type: "image",
    //       gallery: {
    //         enabled: true,
    //         navigateByImgClick: true,

    //         arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button

    //         tPrev: "Previous (Left arrow key)", // title for left button
    //         tNext: "Next (Right arrow key)", // title for right button
    //         tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
    //       },
    //       // callbacks: {
    //       //   buildControls: function () {
    //       //     // re-appends controls inside the main container
    //       //     this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
    //       //   }
    //       // },
    //       verticalFit: true // Fits image in area vertically
    //     });
    // });

    $(".fp-gallery-button").on("click", function (e) {
      e.preventDefault();
      let targetGallerySelector = $(this).data("mfp-src");
      let $items = [];
      $(targetGallerySelector)
        .children(".fp-photo")
        .each(function () {
          $items.push({ src: $(this).children("img").attr("src") });
        });
      $.magnificPopup.open({
        items: $items,
        type: "image",
        gallery: {
          enabled: true
        }
      });
    });

    $("button.view-more").click(function () {
      let htmlString = $(this).attr("aria-expanded");
      let buttonString = $(this).html();
      console.log(htmlString);
      console.log(buttonString);
      if (htmlString == "false") {
        $(this).html("View Less");
        $(this).toggleClass("rotate-arrow");
      } else if (htmlString == "true") {
        $(this).html("View More");
        $(this).toggleClass("rotate-arrow");
      }
      $(this).parents(".featured-item-list").toggleClass("bg-color-2");
      $(this).attr("aria-expanded", function (i, attr) {
        return attr == "true" ? "false" : "true";
      });
      $(this)
        .siblings(".list-wrapper")
        .attr("aria-expanded", function (i, attr) {
          return attr == "true" ? "false" : "true";
        });
      $(this).siblings(".list-wrapper").slideToggle("slow");
    });

    let $toggles = $(".togglize-me").togglize({ action: "toggle", animate: true, animateSpeed: "1s" });
    let $accordions = $(".accordionize-me").togglize({ action: "accordion", animate: true, animateSpeed: "0.5s" });

    /*------------------------------------
  slick slider js
  -------------------------------------*/
    if ($(".slider-half-width").html()) {
      $(".slider-half-width").slick({
        lazyLoad: "ondemand",
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "100px",
        autoplay: true,
        autoplaySpeed: 6000,
        rows: 0,
        infinite: true,
        // appendArrows: ".append-slick-arrows",
        responsive: [
          {
            breakpoint: 980,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false,
              centerPadding: "0",
              lazyLoad: "ondemand",
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              centerMode: false,
              centerPadding: "0",
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      });
    }

    if ($(".simple-slider").html()) {
      $(".simple-slider").slick({
        lazyLoad: "ondemand",
        arrows: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        // centerMode: true,
        // centerPadding: '40px',
        // autoplay: true,
        // autoplaySpeed: 6000,
        rows: 0,
        infinite: true,
        // appendArrows: ".append-slick-arrows",
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              lazyLoad: "ondemand",
              arrows: false,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      });
    }
    $(".slick-next").append("<i class='arrow right'></i>");
    $(".slick-prev").append("<i class='arrow left'></i>");

    // $(".featured-fp-card").slick({
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   // autoplay: true,
    //   // autoplaySpeed: 3000,
    //   infinite: true,
    //   rows: 0,
    //   lazyLoad: "ondemand",
    //   arrows: true,
    //   dots: false,
    //   // centerMode: true,
    //   // centerPadding: "90px",
    //   responsive: [
    //     {
    //       breakpoint: 1080,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         // autoplay: true,
    //         // autoplaySpeed: 3000,
    //         infinite: true,
    //         rows: 0,
    //         lazyLoad: "ondemand",
    //         arrows: false,
    //         dots: true
    //       }
    //     }
    //   ]
    // });
    // $(".slick-next").append("<i class='arrow right'></i>");
    // $(".slick-prev").append("<i class='arrow left'></i>");

    $(".video-control-button").on("click", function (e) {
      // console.log('click',e);
      let $this = $(this);
      let label = $this.attr("aria-label");
      if (label === "play") {
        $this.attr("aria-label", "pause");
        $this.parent().siblings("video").trigger("play");
      } else {
        $this.attr("aria-label", "play");
        $this.parent().siblings("video").trigger("pause");
      }
      console.log("video: ", $this.parent().siblings("video"));
    });

    function reduceAllMotion() {
      console.log("reducing motion...");
      $("video").prop("autoplay", false).siblings(".video-control-button-container").find(".video-control-button").attr("aria-label", "play");
    }

    /**
     * Flag Prefers Reduced Motion
     */
    const reducedMotionMediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!reducedMotionMediaQuery || reducedMotionMediaQuery.matches) {
      reduceAllMotion();
    }

    const $siteNav = $("#site-navigation");

    $("#primary-nav-toggle").on("click", function (e) {
      let $button = $(this);
      // $("body").toggleClass("menu-open");
      let expanded = $button.attr("aria-expanded") == "true";
      $button.next(".menu-main-menu-container").prop("hidden", !expanded);
    });

    let closeMenu = function ($toggleButton, focusButton = false) {
      $toggleButton.attr("aria-expanded", false);
      $toggleButton.next(".menu-main-menu-container").prop("hidden", true);
      // $("body").removeClass("menu-open");
      if (focusButton) {
        $toggleButton.focus();
      }
      return this;
    };

    $siteNav.on("keyup", function (e) {
      const ESC = 27;
      let $toggleButton = $(this).find("#primary-nav-toggle");
      let expanded = $toggleButton.attr("aria-expanded") == "true";
      if (!expanded) {
        return;
      }

      if (e.keyCode == ESC) {
        closeMenu($toggleButton, true);
      }
    });

    $siteNav.find("#primary-menu").on("focusout", function (e) {
      let $navButton = $siteNav.find("#primary-nav-toggle");
      if ($navButton.attr("aria-expanded") == "false") {
        return;
      }
      if ($(e.relatedTarget).parent().hasClass("menu-item") == false) {
        closeMenu($navButton, false);
      }
    });

    if ($('.tabbed').length > 0) {

      const tabbed = document.querySelector(".tabbed");
      const tablist = tabbed.querySelector("ul");
      const tabs = tablist.querySelectorAll("a");
      const panels = tabbed.querySelectorAll('[id^="section"]');

      // The tab switching function
      const switchTab = (oldTab, newTab) => {
        newTab.focus();
        // Make the active tab focusable by the user (Tab key)
        newTab.removeAttribute("tabindex");
        // Set the selected state
        newTab.setAttribute("aria-selected", "true");
        // trigger slick refresh on the slider in the tab whenever a new tab is activated
        // you might need to have the refresh happen right after you change the styles on the section
        // function refreshSlick() {
        //   $(".tabbed li a[aria-selected=true]").parents('div.tabbed-buttons').siblings('div.floorplan-section-container').find('.simple-slider').slick('refresh');
        // }
        // refreshSlick();
        oldTab.removeAttribute("aria-selected");
        oldTab.setAttribute("tabindex", "-1");
        // Get the indices of the new and old tabs to find the correct
        // tab panels to show and hide
        let index = Array.prototype.indexOf.call(tabs, newTab);
        let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
        panels[oldIndex].hidden = true;
        panels[index].hidden = false;
      };

      // Add the tablist role to the first <ul> in the .tabbed container
      tablist.setAttribute("role", "tablist");

      // Add semantics are remove user focusability for each tab
      Array.prototype.forEach.call(tabs, (tab, i) => {
        tab.setAttribute("role", "tab");
        tab.setAttribute("id", "tab" + (i + 1));
        tab.setAttribute("tabindex", "-1");
        tab.parentNode.setAttribute("role", "presentation");

        // Handle clicking of tabs for mouse users
        tab.addEventListener("click", e => {
          e.preventDefault();
          let currentTab = tablist.querySelector("[aria-selected]");
          if (e.currentTarget !== currentTab) {
            switchTab(currentTab, e.currentTarget);
          }
        });

        // Handle keydown events for keyboard users
        tab.addEventListener("keydown", e => {
          // Get the index of the current tab in the tabs node list
          let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
          // Work out which key the user is pressing and
          // Calculate the new tab's index where appropriate
          let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? "down" : null;
          if (dir !== null) {
            e.preventDefault();
            // If the down key is pressed, move focus to the open panel,
            // otherwise switch to the adjacent tab
            dir === "down" ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
          }
        });
      });


      // Add tab panel semantics and hide them all
      Array.prototype.forEach.call(panels, (panel, i) => {
        panel.setAttribute("role", "tabpanel");
        panel.setAttribute("tabindex", "-1");
        let id = panel.getAttribute("id");
        panel.setAttribute("aria-labelledby", tabs[i].id);
        panel.hidden = true;
      });
      // Initially activate the first tab and reveal the first tab panel
      tabs[0].removeAttribute("tabindex");
      tabs[0].setAttribute("aria-selected", "true");
      panels[0].hidden = false;
    }

  });

  // close banner button
  $(".site-banner button.close-section").on("click", function () {
    $(".site-banner").slideUp();
  });
})(jQuery);
